// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"ImageCancelable__spinnerWrapper--2Rhdi"};